export function getRequestIdle() {
    return (window.requestIdleCallback || window.requestAnimationFrame).bind(window);
}
export function getCancelIdle() {
    return (window.cancelIdleCallback || window.cancelAnimationFrame).bind(window);
}
export function idle() {
    return new Promise((resolve) => {
        getRequestIdle()(resolve);
    });
}
//# sourceMappingURL=idle.js.map